import React from "react";

import { Skeleton } from "@mui/material";
import SkeletonComponent from "Components/Generic/Skeleton";
import { Location as LocationIcon, Icon } from "iconsax-react";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardTitle,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "./styled";

type Action = {
  label: string;
  Icon: Icon;
  onClick?: () => void;
};

interface SummaryDetailsSectionCardProps {
  title: string;
  items: string[];
  isLoading?: boolean;
  actions?: Action[];
}

export const SummaryJobDetailsSectionCard = (props: SummaryDetailsSectionCardProps) => {
  const { title, items, isLoading, actions } = props;

  const renderLoadingItems = () => {
    if (isLoading) {
      return Array.from({ length: 2 }).map((_item, index) => {
        return <Skeleton variant="text" sx={{ fontSize: "1rem" }} key={index} />;
      });
    }
  };

  const renderListItems = () => {
    if (!items.length || isLoading) return;

    return items.map((item, index) => {
      return (
        <ListItem disablePadding key={index} alignItems="flex-start">
          <ListItemIcon>
            <LocationIcon size={20} />
          </ListItemIcon>

          <ListItemText>{item}</ListItemText>
        </ListItem>
      );
    });
  };

  const renderCardActions = () => {
    return (actions || []).map((action) => (
      <React.Fragment key={action.label}>
        <Divider />

        <CardActions>
          <SkeletonComponent isLoading={!!isLoading}>
            <Button
              startIcon={<action.Icon size={20} />}
              onClick={action.onClick}
              isClickable={!!action.onClick}
            >
              {action.label}
            </Button>
          </SkeletonComponent>
        </CardActions>
      </React.Fragment>
    ));
  };

  return (
    <Card elevation={0} fullHeight>
      <CardContent>
        <CardTitle>{title}</CardTitle>

        <List disablePadding>
          {renderLoadingItems()}
          {renderListItems()}
        </List>
      </CardContent>

      {renderCardActions()}
    </Card>
  );
};
